import { auth, db } from "@/services/firebase.service";
import { UserService } from "@/services/user.service";
import router from "@/router";

export default {
    initAuthentication({ dispatch, commit, state }) {
        return new Promise(resolve => {
            // unsubscribe observer if already listening
            if (state.unsubscribeAuthObserver) {
                state.unsubscribeAuthObserver();
            }

            const unsubscribe = auth.onAuthStateChanged(user => {
                if (user) {
                    dispatch("fetchAuthUser").then(dbUser => resolve(dbUser));
                } else {
                    resolve(null);
                }
            });
            commit("SET_UNSUBSCRIBE_AUTH_OBSERVER", unsubscribe);
        });
    },

    async registerUserWithEmailAndPassword({ dispatch, commit }, payload) {
        commit("SET_LOADING", true);
        try {
            const result = await UserService.register(payload);
            await commit("SET_LOADING", false);
            if (result.status === 200) {
                await dispatch("signInWithEmailAndPassword", {
                    email: payload.email,
                    password: payload.password
                }).then(() => {
                    const user = auth.currentUser;
                    user.sendEmailVerification()
                        .then(function() {
                            console.log(" Email sent.");
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                });
                return "success";
            } else {
                return "error";
            }
        } catch (error) {
            commit("SET_ERROR", error);
            commit("SET_LOADING", false);
        }
    },

    async signInWithEmailAndPassword(
        { dispatch, commit },
        { email, password }
    ) {
        try {
            const result = await UserService.login(email, password);
            if (result.name !== "Error") {
                await dispatch("user/fetchUser", auth.currentUser.uid, {
                    root: true
                });
                commit("SET_AUTH_ID", auth.currentUser.uid);
            }

            return "success";
        } catch (error) {
            commit("SET_ERROR", error);
            return "error";
        }
    },

    signOut({ commit }) {
        return auth.signOut().then(() => {
            commit("SET_AUTH_ID", null);
            router.go();
        });
    },

    async fetchAuthUser({ commit }) {
        try {
            const user = await db
                .collection("users")
                .doc(auth.currentUser.uid)
                .get();
            await commit("SET_AUTH_ID", user.id);
            return user.data();
        } catch (error) {
            console.log(error);
        }
    }
};
